import { AUTH_SERVICE_URL } from 'config';

const AUTH_API_V1_URL = `${AUTH_SERVICE_URL}/api/v1/auth`;

export const AUTH_API_V1_URL_CHANGE_PASSWORD = `${AUTH_API_V1_URL}/sparemin/password`;

export const AUTH_API_V1_VERIFICATION_PATH = `${AUTH_API_V1_URL}/verification`;
